import React from 'react';
import './LoginStyles.css';
import { useAuth } from '../../AuthContext'; // Make sure the import path is correct
import Carousel from 'react-bootstrap/Carousel';
import Venezuela2 from '../Images/Venezuela2.jpg';
import Canada from '../Images/Canada.jpg';
import China from '../Images/China.jpg';
import Philippines from '../Images/Philippines.jpg';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Link } from 'react-router-dom';
import './Content.css';

function Home() {
  const { isLoggedIn, userDetails } = useAuth(); // Use the context to access isLoggedIn and userName

  return (
    <div className='container'>
      <div className='card mt-4 body'>
        <div className='card-body'>
          <h2>Welcome to Culture Compass!</h2>
          <p>Embark on a journey of cultural discovery, understanding, and connection. Explore surveys, view scoreboards,
            and engage with a community that celebrates the diversity of cultures around the world.
            Let's navigate the rich tapestry of human culture together.</p>
          {/* Use isLoggedIn and userDetails to access the user's first and last name */}
          {isLoggedIn ? (
            <p>Welcome back, {`${userDetails.firstName}`}!</p> // Updated to use userDetails
          ) : (
            <p>Please log in or sign up using the navigation bar above.</p>
          )}
        </div>
      </div>
      <section id='home' className='carousel-block'>
        <Carousel>
          <Carousel.Item>
            <img img className="d-block w-100" src={Venezuela2} alt="First slide"
              style={{ maxHeight: '400px', objectFit: 'cover', filter: 'brightness(70%) contrast(120%)' }}
            />
            <Carousel.Caption>
              <h3>Venezuela</h3>
              <p style={{ color: '#ffffff' }}>Explore the vibrant culture of Venezuela and dive deeper into its traditions,
                customs, and history. Click 'Learn More' to embark on an enlightening journey and prepare for the exciting surveys ahead!</p>
              <Link className='btn btn-success' to='/VenezuelaSection'>Learn More <i className='fas fa-chevron-right'></i></Link>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img img className="d-block w-100" src={Canada} alt="Second slide"
              style={{ maxHeight: '400px', objectFit: 'cover', filter: 'brightness(70%) contrast(120%)' }}
            />
            <Carousel.Caption>
              <h3>Canada</h3>
              <p style={{ color: '#ffffff' }}>Discover the diverse cultural tapestry of Canada, from its stunning natural landscapes to its rich multicultural
                heritage. Click 'Learn More' to delve into the unique traditions and experiences of this vibrant nation!</p>
              <Link className='btn btn-success' to='/CanadaSection'>Learn More <i className='fas fa-chevron-right'></i></Link>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img img className="d-block w-100" src={China} alt="Third slide"
              style={{ maxHeight: '400px', objectFit: 'cover', filter: 'brightness(70%) contrast(120%)' }}
            />
            <Carousel.Caption>
              <h3>China</h3>
              <p style={{ color: '#ffffff' }}>Embark on a journey through ancient traditions and modern wonders in China. Uncover the secrets of this fascinating civilization
                and immerse yourself in its rich history and timeless beauty. Click 'Learn More' to explore the wonders of China!</p>
              <Link className='btn btn-success' to='/ChinaSection'>Learn More <i className='fas fa-chevron-right'></i></Link>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img img className="d-block w-100" src={Philippines} alt="Fourth slide"
              style={{ maxHeight: '400px', objectFit: 'cover', filter: 'brightness(70%) contrast(120%)' }}
            />
            <Carousel.Caption>
              <h3>Philippines</h3>
              <p style={{ color: '#ffffff' }}>Experience the warmth and hospitality of the Philippines as you discover its breathtaking landscapes and vibrant culture.
                From its pristine beaches to its bustling cities, the Philippines offers a treasure trove of experiences waiting to be explored. Click 'Learn More' to start your adventure in the Philippines!</p>
              <Link className='btn btn-success' to='/PhillipinesSection'>Learn More <i className='fas fa-chevron-right'></i></Link>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </section>
    </div>
  );
}

export default Home;
